const guia = {
  hero: {
    badge: 'Inteligência de Mercado',
    title1: 'Guia de Preços por',
    title2: ' Bairro e Cidade 2025',
    description: 'Entenda os valores de mercado local com preço médio por m² / sq ft, tendências ano a ano e scores de bairros em Miami (Flórida, EUA), São Paulo e Brasília.',
    statCities: '3 Cidades',
    statNeighborhoods: '20 Bairros',
    statTrends: 'Tendências 5 Anos',
    statAi: 'Dados Gerados por IA',
  },
  pulse: {
    title: 'Pulso do Mercado',
    subtitle: '3 mercados · Últimas atualizações',
    updated: 'Atualizado em',
    viewGuide: 'Ver guia',
    recentUpdates: 'atualizações recentes',
    badgePrices: 'Preços',
    badgeTrend: 'Tendência',
    disclaimer: '<0>Apenas para Fins Educativos — Aviso sobre Dados Gerados por IA:</0> As médias de preço por m² / sq ft, taxas de crescimento ano a ano e scores de bairros apresentados nesta página são estimativas geradas por IA, compiladas a partir de relatórios de mercado disponíveis publicamente, índices imobiliários (FipeZAP, ZAP Imóveis, CondoBlackBook) e fontes de terceiros de 2024–2025. Esses dados podem estar desatualizados, incompletos ou imprecisos. Têm como objetivo exclusivo fins educativos e informativos gerais e não constituem aconselhamento financeiro, de investimento ou imobiliário. <1>Carvalho\'s Imobiliária não se responsabiliza por erros, omissões ou decisões tomadas com base nestas informações.</1> Sempre consulte um profissional imobiliário licenciado e realize due diligence independente antes de tomar qualquer decisão de investimento.',
  },
  citySelector: {
    title: 'Selecione uma Cidade',
    subtitle: 'Clique para explorar bairros e dados de preços',
    selected: 'Selecionado',
    listings: 'imóveis',
    avgPrice: 'Preço médio',
    yoyGrowth: 'Var. anual',
    viewFullGuide: 'Ver guia completo de',
  },
  miamiDetail: {
    description: 'Miami é um dos mercados imobiliários de luxo mais dinâmicos do mundo, atraindo investidores internacionais e compradores ultra-high-net-worth. A cidade combina estilo de vida tropical, comodidades de classe mundial e forte potencial de valorização. Em 2025, os preços de condomínios de luxo ultrapassaram $1.000/sq ft em média pela primeira vez na história.',
    avgPrice: 'Preço Médio',
    yoyGrowth: 'Cresc. Anual',
    neighborhoods: 'Bairros',
    activeListings: 'Imóveis Ativos',
    priceEvolution: 'Evolução do Preço Médio',
    since2020: '+54,5% desde 2020',
    currentAvg: 'Média atual (2025)',
    neighborhoodsTitle: 'Bairros de Miami',
    neighborhoodsFound: '7 bairros encontrados',
    searchPlaceholder: 'Buscar bairros...',
    sortPrice: 'Preço',
    sortGrowth: 'Crescimento',
    sortAZ: 'A–Z',
    pricePerSqft: 'Preço médio por sq ft',
    yoyVar: 'Var. anual',
    walkability: 'Caminhabilidade',
    infrastructure: 'Infraestrutura',
    appreciation: 'Valorização',
    viewFullGuide: 'Ver Guia Completo',
  },
  priceTable: {
    title: 'Comparativo Completo de Preços',
    subtitle: 'Todos os bairros ordenados por preço médio por unidade',
    colNeighborhood: 'Bairro',
    colCity: 'Cidade',
    colAvgPrice: 'Preço Médio',
    colYoY: 'Var. Anual',
    colMarketType: 'Tipo de Mercado',
    colListings: 'Imóveis',
  },
  compare: {
    title: 'Ferramenta interativa',
    subtitle: 'Compare mercados lado a lado',
    description: 'Selecione dois mercados e compare preços, yield, scores de investimento e perfil ideal.',
    marketA: 'Mercado A',
    marketB: 'Mercado B',
    metric: 'Métrica',
    overview: 'Visão Geral',
    returnYield: 'Retorno & Yield',
    investmentScores: 'Scores de Investimento (0–10)',
    overallScore: 'Score Geral',
    profileAnalysis: 'Perfil & Análise',
    strengths: 'Pontos fortes',
    risks: 'Principais riscos',
    viewAnalysis: 'Ver análise completa por bairro',
    viewMiamiGuide: 'Ver guia de Miami',
    viewSPGuide: 'Ver guia de São Paulo',
    footerNote: 'Scores são estimativas editoriais com base em índices públicos (FipeZAP, Zillow, Q1 2025). Não constituem assessoria financeira.',
    of10: 'em 10',
    currency: 'Moeda',
    entryPrice: 'Preço de entrada (mín.)',
    avgPrice: 'Preço médio',
    topMarket: 'Topo de mercado',
    yoyAppreciation: 'Valorização YoY',
    rentalYield: 'Yield de aluguel',
    recommendedHorizon: 'Horizonte recomendado',
    marketLiquidity: 'Liquidez de mercado',
    appreciationPotential: 'Potencial de valorização',
    passiveIncome: 'Renda passiva',
    idealProfile: 'Perfil ideal do investidor',
    locationMiami: 'Flórida, EUA',
    locationSP: 'São Paulo, Brasil',
    currencyA: 'USD · Dólar americano',
    currencyB: 'BRL · Real brasileiro',
    yieldA: '5–8% a.a.',
    yieldB: '4–6% a.a.',
    horizonA: '5–10 anos',
    horizonB: '3–10 anos',
    idealProfileA: 'Diversificação internacional, proteção cambial e horizonte de longo prazo (5–10 anos)',
    idealProfileB: 'Máxima liquidez, diversidade de bairros e exposição ao maior hub financeiro da América Latina',
    strengthsA: ['0% imposto estadual FL', 'Short-term rental viável', 'Mercado internacional', 'Hedge cambial BRL/USD', 'Valorização acumulada +54% (5 anos)'],
    strengthsB: ['Maior mercado da LATAM', 'Liquidez máxima', 'Diversidade de bairros e faixas', 'Hub corporativo Faria Lima'],
    risksA: ['Risco cambial (BRL/USD)', 'Custos de manutenção altos', 'Seguros obrigatórios (furacões)', 'Burocracia para não-residentes'],
    risksB: ['ITBI + carga tributária alta', 'Oferta elevada em alguns bairros', 'Valorização mais gradual'],
  },
  country: {
    usa: 'EUA',
    brazil: 'Brasil',
  },
  cta: {
    title: 'Pronto para investir no bairro certo?',
    specialist: 'Especialista em Inteligência de Mercado',
    description: 'Nossos especialistas conhecem cada mercado por dentro. Receba orientação personalizada hoje.',
    whatsapp: 'Falar com Especialista no WhatsApp',
    browse: 'Ver Todos os Imóveis',
  },
  spHighlight: {
    title: 'Itaim Bibi lidera valorização em SP com +11,3% YoY no T1 2026',
    subtitle: 'Eixo Faria Lima mantém demanda aquecida com novos escritórios de fundos internacionais na região.',
  },
  brasiliaHighlight: {
    title: 'FipeZAP: DF lidera valorização entre capitais com +12,6% em 2025',
    subtitle: 'Sudoeste e Noroeste puxam a alta — preço médio no Plano Piloto atinge R$14.300/m².',
  },
  miamiHighlight: {
    title: 'Sunny Isles supera US$2.000/sq ft pela primeira vez na história',
    subtitle: 'Bentley Residences e Porsche Design Tower elevam o piso de preços da região ao recorde histórico.',
  },
  florianopolisHighlight: {
    title: 'Balneário Camboriú mantém o m² mais caro do Brasil: R$ 24.500 em 2026',
    subtitle: 'Jurerê Internacional e mercado de luxo catarinense atraem investidores de alto padrão do país inteiro.',
  },
  cityPages: {
    shared: {
      marketPulse: 'Market Pulse',
      updates: '3 atualizações',
      updatedOn: 'Atualizado em',
      disclaimerWarning: 'Aviso',
      disclaimerMiami: 'Dados de preços são estimativas baseadas em índices públicos (CondoBlackBook, Zillow, Q1 2025). Não constituem assessoria financeira. Consulte um profissional antes de qualquer decisão de investimento.',
      disclaimerBR: 'Dados de preços são estimativas baseadas em índices públicos (FipeZAP, ZAP Imóveis, 2025). Não constituem assessoria financeira. Consulte um profissional antes de qualquer decisão de investimento.',
      interactiveTool: 'Ferramenta interativa',
      compareHeading: 'Compare mercados lado a lado',
      compareSubtitle: 'Selecione dois mercados e compare preços, yield, scores de investimento e perfil ideal.',
      marketA: 'Mercado A',
      marketB: 'Mercado B',
      vs: 'VS',
      metric: 'Métrica',
      overview: 'Visão Geral',
      returnYield: 'Retorno & Yield',
      investmentScores: 'Scores de Investimento (0–10)',
      overallScore: 'Score Geral',
      profileAnalysis: 'Perfil & Análise',
      idealProfile: 'Perfil ideal do investidor',
      strengths: 'Pontos fortes',
      risks: 'Principais riscos',
      viewAnalysis: 'Ver análise completa por bairro',
      footerNote: 'Scores são estimativas editoriais com base em índices públicos (FipeZAP, Zillow, Q1 2025). Não constituem assessoria financeira.',
      of10: 'em 10',
      currency: 'Moeda',
      entryPrice: 'Preço de entrada (mín.)',
      avgPrice: 'Preço médio',
      topMarket: 'Topo de mercado',
      yoyAppreciation: 'Valorização YoY',
      rentalYield: 'Yield de aluguel',
      recommendedHorizon: 'Horizonte recomendado',
      marketLiquidity: 'Liquidez de mercado',
      appreciationPotential: 'Potencial de valorização',
      passiveIncome: 'Renda passiva',
      faqBadge: 'Dúvidas Frequentes',
      viewAllFaqs: 'Ver todas as perguntas na central de FAQ',
      exploreBadge: 'Market Guide',
      exploreTitle: 'Explore outros mercados',
      exploreSubtitle: 'Análise detalhada dos principais destinos de investimento imobiliário.',
      exploreViewAll: 'Ver todos os mercados',
      avgPriceLabel: 'Preço médio',
      yoyLabel: 'Valorização YoY',
      viewFullGuide: 'Ver guia completo',
      colRank: '#',
      colNeighborhood: 'Bairro',
      colPrice: 'Preço médio',
      colYoY: 'Var. YoY',
      colProfile: 'Perfil',
      colListings: 'Listings',
      hot: 'Hot',
      top: 'Top',
      currencyLabel: 'Moeda',
      ctaWhatsapp: 'Falar com especialista agora',
      falarConsultor: 'Falar com consultor',
    },
    miami: {
      heroBadge: 'Miami · Florida',
      heroTitle: 'Melhores Bairros de Miami',
      heroTitleHighlight: 'para Investir em 2025',
      heroDescription: 'Miami consolidou-se como o principal destino de investimento imobiliário dos brasileiros nos Estados Unidos. Com preços médios acima de US$1.000/sq ft, valorização histórica de dois dígitos e isenção de imposto estadual sobre renda, a cidade oferece um dos melhores retornos ajustados ao risco do mundo.',
      heroCtaProperties: 'Ver imóveis em Miami',
      heroCtaContact: 'Falar com consultor',
      location: 'Miami, FL',
      countryLabel: 'Florida, EUA',
      currencyA: 'USD · Dólar americano',
      currencyB: 'BRL · Real brasileiro',
      strengthsA: ['0% imposto estadual FL', 'Short-term rental viável', 'Mercado internacional', 'Hedge cambial BRL/USD', 'Valorização acumulada +54% (5 anos)'],
      strengthsB: ['Maior mercado da LATAM', 'Liquidez máxima', 'Diversidade de bairros e faixas', 'Hub corporativo Faria Lima'],
      risksA: ['Risco cambial (BRL/USD)', 'Custos de manutenção altos', 'Seguros obrigatórios (furacões)', 'Burocracia para não-residentes'],
      risksB: ['ITBI + carga tributária alta', 'Oferta elevada em alguns bairros', 'Valorização mais gradual'],
      idealProfileA: 'Diversificação internacional, proteção cambial e horizonte de longo prazo (5–10 anos)',
      idealProfileB: 'Máxima liquidez, diversidade de bairros e exposição ao maior hub financeiro da América Latina',
      entryPriceA: 'US$ 400.000',
      entryPriceB: 'R$ 350.000',
      avgPriceA: 'US$ 1.100/sq ft',
      avgPriceB: 'R$ 11.800/m²',
      topMarketA: 'US$ 3.800/sq ft · Bal Harbour',
      topMarketB: 'R$ 32.000/m² · Cidade Jardim',
      yieldA: '5–8% a.a.',
      yieldB: '4–6% a.a.',
      horizonA: '5–10 anos',
      horizonB: '3–10 anos',
      liquidityA: '9.2',
      liquidityB: '10.0',
      appreciationA: '9.0',
      appreciationB: '7.0',
      passiveIncomeA: '8.0',
      passiveIncomeB: '7.0',
      overallScoreA: '8.7',
      overallScoreB: '8.0',
      scoreWidthA: '87%',
      scoreWidthB: '80%',
      viewGuideA: 'Ver guia de Miami',
      viewGuideB: 'Ver guia de São Paulo',
      whyInvestTitle: 'Por que investir em Miami?',
      whyInvestSubtitle: '4 razões que fazem de Miami o maior destino de investimento imobiliário dos brasileiros nos EUA.',
      neighborhoodsTitle: 'Bairros de Miami — Análise Completa',
      neighborhoodsSubtitle: 'Clique em qualquer bairro para ver preços detalhados, scores e destaques do mercado.',
      rankingTitle: 'Ranking de preços — Bairros de Miami',
      rankingSubtitle: 'Comparativo ordenado por preço médio por sq ft · Q1 2025',
      howToBuyBadge: 'Guia para Brasileiros',
      howToBuyTitle: 'Como comprar imóvel em Miami sendo brasileiro',
      howToBuySubtitle: 'Passo a passo para investidores brasileiros adquirirem imóveis nos EUA com segurança jurídica e eficiência fiscal.',
      howToBuyHelpTitle: 'Quer ajuda com todo esse processo?',
      howToBuyHelpSubtitle: 'Nossa equipe orienta brasileiros do ITIN à entrega das chaves — sem custo adicional.',
      howToBuyHelpCTA: 'Falar com especialista',
      faqTitle: 'Perguntas sobre investir em Miami',
      faqSubtitle: 'As principais dúvidas de investidores brasileiros sobre compra de imóveis em Miami — respondidas por especialistas.',
      exploreCardBrasiliaTitle: 'Brasília',
      exploreCardBrasiliaSubtitle: 'Capital federal com maior renda per capita do Brasil, patrimônio UNESCO e mercado resiliente.',
      exploreCardBrasiliaBadge: 'Distrito Federal',
      exploreCardBrasiliaPrice: 'R$12.000/m²',
      exploreCardBrasiliaYoY: '+12,6%',
      exploreCardBrasiliaYoYLabel: 'Maior alta do ano',
      exploreCardSPTitle: 'São Paulo',
      exploreCardSPSubtitle: 'Maior mercado imobiliário da América Latina. Faria Lima, Itaim Bibi e o eixo de valorização contínua.',
      exploreCardSPBadge: 'São Paulo, Brasil',
      exploreCardSPPrice: 'R$11.800/m²',
      exploreCardSPYoY: '+8,7%',
      exploreCardSPYoYLabel: 'Valorização YoY',
      ctaTitle: 'Pronto para investir em Miami?',
      ctaSubtitle: 'Nossa equipe especializada em imóveis em Miami atende brasileiros há mais de 9 anos. Do ITIN à entrega das chaves.',
      ctaSecondary: 'Ver imóveis em Miami',
    },
    saoPaulo: {
      heroBadge: 'São Paulo · SP',
      heroTitle: 'Melhores Bairros de São Paulo',
      heroTitleHighlight: 'para Investir em 2025',
      heroDescription: 'São Paulo é a capital financeira do Brasil e o maior mercado imobiliário da América Latina. Com mais de 12 milhões de habitantes, PIB equivalente ao de países inteiros e valorização média de +8,7% em 2025, a cidade oferece oportunidades únicas para investidores que buscam renda, valorização ou diversificação patrimonial.',
      heroCtaProperties: 'Ver imóveis em São Paulo',
      heroCtaContact: 'Falar com consultor',
      location: 'São Paulo, SP',
      countryLabel: 'São Paulo, Brasil',
      currencyA: 'BRL · Real brasileiro',
      currencyB: 'USD · Dólar americano',
      strengthsA: ['Maior mercado da LATAM', 'Liquidez máxima', 'Diversidade de bairros e faixas', 'Hub corporativo Faria Lima'],
      strengthsB: ['0% imposto estadual FL', 'Short-term rental viável', 'Mercado internacional', 'Hedge cambial BRL/USD', 'Valorização acumulada +54% (5 anos)'],
      risksA: ['ITBI + carga tributária alta', 'Oferta elevada em alguns bairros', 'Valorização mais gradual'],
      risksB: ['Risco cambial (BRL/USD)', 'Custos de manutenção altos', 'Seguros obrigatórios (furacões)', 'Burocracia para não-residentes'],
      idealProfileA: 'Máxima liquidez, diversidade de bairros e exposição ao maior hub financeiro da América Latina',
      idealProfileB: 'Diversificação internacional, proteção cambial e horizonte de longo prazo (5–10 anos)',
      entryPriceA: 'R$ 350.000',
      entryPriceB: 'US$ 400.000',
      avgPriceA: 'R$ 11.800/m²',
      avgPriceB: 'US$ 1.100/sq ft',
      topMarketA: 'R$ 32.000/m² · Cidade Jardim',
      topMarketB: 'US$ 3.800/sq ft · Bal Harbour',
      yieldA: '4–6% a.a.',
      yieldB: '5–8% a.a.',
      horizonA: '3–10 anos',
      horizonB: '5–10 anos',
      liquidityA: '10.0',
      liquidityB: '9.2',
      appreciationA: '7.0',
      appreciationB: '9.0',
      passiveIncomeA: '7.0',
      passiveIncomeB: '8.0',
      overallScoreA: '8.0',
      overallScoreB: '8.7',
      scoreWidthA: '80%',
      scoreWidthB: '87%',
      viewGuideA: 'Ver guia de São Paulo',
      viewGuideB: 'Ver guia de Miami',
      whyInvestTitle: 'Por que investir em São Paulo?',
      whyInvestSubtitle: '4 razões que fazem de São Paulo o maior destino de investimento imobiliário da América Latina.',
      neighborhoodsTitle: 'Bairros de São Paulo — Análise Completa',
      neighborhoodsSubtitle: 'Clique em qualquer bairro para ver preços detalhados, scores e perfil do mercado.',
      rankingTitle: 'Ranking de preços — Bairros de São Paulo',
      rankingSubtitle: 'Comparativo ordenado por preço médio por m² · 2025',
      faqTitle: 'Perguntas sobre imóveis em São Paulo',
      faqSubtitle: 'As principais dúvidas de compradores e investidores sobre o maior mercado imobiliário da América Latina.',
      exploreCardMiamiTitle: 'Miami',
      exploreCardMiamiSubtitle: 'O principal destino dos brasileiros nos EUA — dólar forte, yield alto e mercado internacional.',
      exploreCardMiamiBadge: 'Florida, EUA',
      exploreCardMiamiPrice: '$1.100/sq ft',
      exploreCardMiamiYoY: '+18%',
      exploreCardMiamiYoYLabel: 'Valorização YoY',
      exploreCardBrasiliaTitle: 'Brasília',
      exploreCardBrasiliaSubtitle: 'Capital federal com maior renda per capita do Brasil, patrimônio UNESCO e mercado resiliente.',
      exploreCardBrasiliaBadge: 'Distrito Federal',
      exploreCardBrasiliaPrice: 'R$12.000/m²',
      exploreCardBrasiliaYoY: '+12,6%',
      exploreCardBrasiliaYoYLabel: 'Maior alta do ano',
      ctaTitle: 'Pronto para investir em São Paulo?',
      ctaSubtitle: 'Nossa equipe especializada no mercado paulistano orienta você da escolha do bairro à assinatura do contrato — sem custo adicional.',
      ctaSecondary: 'Ver imóveis em São Paulo',
    },
    brasilia: {
      heroBadge: 'Brasília · Distrito Federal',
      heroTitle: 'Melhores Bairros de Brasília',
      heroTitleHighlight: 'para Comprar Imóvel em 2025',
      heroDescription: 'Brasília registrou crescimento de 12,6% nos preços de imóveis novos em 2025 — o maior entre as capitais brasileiras. Capital federal com renda per capita entre as mais altas do Brasil, demanda pública estável e oferta naturalmente restrita pelo tombamento urbanístico fazem da cidade um dos mercados mais resilientes do país.',
      heroCtaProperties: 'Ver imóveis em Brasília',
      heroCtaContact: 'Falar com consultor',
      location: 'Brasília, DF',
      countryLabel: 'Distrito Federal, Brasil',
      currencyA: 'BRL · Real brasileiro',
      currencyB: 'BRL · Real brasileiro',
      strengthsA: ['Oferta limitada por UNESCO', 'Maior renda per capita BR', 'Demanda pública estável', 'Mercado resiliente em crises'],
      strengthsB: ['Maior mercado da LATAM', 'Liquidez máxima', 'Diversidade de bairros e faixas', 'Hub corporativo Faria Lima'],
      risksA: ['Liquidez mais regional', 'Dependência de verbas federais', 'Mercado menos diversificado'],
      risksB: ['ITBI + carga tributária alta', 'Oferta elevada em alguns bairros', 'Valorização mais gradual'],
      idealProfileA: 'Perfil conservador buscando segurança patrimonial e renda estável de servidores públicos',
      idealProfileB: 'Máxima liquidez, diversidade de bairros e exposição ao maior hub financeiro da América Latina',
      entryPriceA: 'R$ 450.000',
      entryPriceB: 'R$ 350.000',
      avgPriceA: 'R$ 12.000/m²',
      avgPriceB: 'R$ 11.800/m²',
      topMarketA: 'R$ 16.500/m² · Sudoeste',
      topMarketB: 'R$ 32.000/m² · Cidade Jardim',
      yieldA: '~5% a.a.',
      yieldB: '4–6% a.a.',
      horizonA: '3–7 anos',
      horizonB: '3–10 anos',
      liquidityA: '7.0',
      liquidityB: '10.0',
      appreciationA: '8.0',
      appreciationB: '7.0',
      passiveIncomeA: '7.0',
      passiveIncomeB: '7.0',
      overallScoreA: '7.3',
      overallScoreB: '8.0',
      scoreWidthA: '73%',
      scoreWidthB: '80%',
      viewGuideA: 'Ver guia de Brasília',
      viewGuideB: 'Ver guia de São Paulo',
      whyInvestTitle: 'Por que investir em Brasília?',
      whyInvestSubtitle: '4 fatores estruturais que fazem de Brasília um dos mercados imobiliários mais resilientes do Brasil.',
      neighborhoodsTitle: 'Bairros de Brasília — Análise Completa',
      neighborhoodsSubtitle: 'Clique em qualquer bairro para ver preços detalhados, scores e perfil do mercado.',
      rankingTitle: 'Ranking de preços — Bairros de Brasília',
      rankingSubtitle: 'Comparativo ordenado por preço médio por m² · 2025',
      faqTitle: 'Perguntas sobre imóveis em Brasília',
      faqSubtitle: 'As principais dúvidas de compradores e investidores sobre o mercado imobiliário de Brasília e do Distrito Federal.',
      exploreCardMiamiTitle: 'Miami',
      exploreCardMiamiSubtitle: 'O principal destino dos brasileiros nos EUA — dólar forte, yield alto e mercado internacional.',
      exploreCardMiamiBadge: 'Florida, EUA',
      exploreCardMiamiPrice: '$1.100/sq ft',
      exploreCardMiamiYoY: '+18%',
      exploreCardMiamiYoYLabel: 'Valorização YoY',
      exploreCardSPTitle: 'São Paulo',
      exploreCardSPSubtitle: 'Maior mercado imobiliário da América Latina. Faria Lima, Itaim Bibi e o eixo de valorização contínua.',
      exploreCardSPBadge: 'São Paulo, Brasil',
      exploreCardSPPrice: 'R$11.800/m²',
      exploreCardSPYoY: '+8,7%',
      exploreCardSPYoYLabel: 'Valorização YoY',
      ctaTitle: 'Pronto para investir em Brasília?',
      ctaSubtitle: 'Nossa equipe especializada no mercado do DF orienta você da escolha do bairro até a assinatura do contrato — sem custo adicional.',
      ctaSecondary: 'Ver imóveis em Brasília',
    },
  },
};

export default guia;